import { LINKS } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/links';
import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/register-verify-phone-number';
import { hasLength, useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { completePhoneConfirmation } from '../../api/profile.ts';

function RegisterVerifyPhoneNumber() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      verification: '',
    },
    validate: {
      verification: hasLength(6, 'Verification code must be exactly 6 characters'),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    setIsLoading(true);
    completePhoneConfirmation(localStorage.getItem('ffm_register_phone_number_confirmation')!, {
      code: values.verification,
    })
      .then(() => {
        navigate(LINKS.REGISTER_ACCOUNT);
      })
      .catch((error) => {
        form.setErrors({
          verification: error.response.data.fields?.find(
            (field: { fieldName: string; message: string }) => field.fieldName === 'code',
          )?.message,
        });
      });
  };

  return <Screen form={form} handleSubmit={handleSubmit} isLoading={isLoading} />;
}

export default RegisterVerifyPhoneNumber;
